import $ from 'jquery';
import LZString from 'lz-string';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import logo from './../../assets/img/favicon-dark.png';
import CommonUtils from '../../util/CommonUtils';
import SessionManager from '../../routes/SessionManager';
import API from '../../service/SiteKickAPIService';

let timezone;
let zones = {};
let zonesMap = {};
let pdfTitle = 'Environmental Report';

function EnvironmentalReport(props) {

    const [user, setUser] = useState(null);
    const [date, setDate] = useState(props.pickedDate ? props.pickedDate : moment().format("YYYY-MM-DD"));
    const [weekly, setWeekly] = useState();
    const [locationChartData, setLocationChartData] = useState({});
    const [sensorChartData, setSensorChartData] = useState({});
    const [sensors_info, setSensorsInfo] = useState([]);
    const [sensorsList, setSensorsList] = useState([]);

    const getPathParams = () => {
        var pathParams = window.location.search;
        pathParams = pathParams.length > 0 ? pathParams.substring(1) : '';
        return pathParams.length > 0 ? JSON.parse(LZString.decompressFromBase64(pathParams)) : {};
    }

    useEffect(() => {
        document.body.style.backgroundColor = '#fff';
        var pdfData = getPathParams();

        let sessionManager = new SessionManager();
        sessionManager.storeCookie('user', pdfData);

        pdfTitle = pdfData.weekly ? 'Environmental Weekly Report' : 'Environmental Daily Report'
        timezone = pdfData.site_selected.site_iana_timezone;
        setUser(pdfData);
        setDate(pdfData.date);
        setWeekly(pdfData.weekly);

        for (let z of pdfData.zones) {
            zones[z.location_id] = z;
            zonesMap[z.location_id] = z.location_name;
        }
        // console.log('this.zones ' + JSON.stringify(zones));

        if (!timezone)
            timezone = moment.tz.guess();
    }, [date])

    useEffect(() => {
        async function fetchData() {
            await fetchSiteLocationSensors();
        }
        if (user !== null && user.site_selected) {
            fetchData();
            fetchEnvironmentalReport();
        }
    }, [user]);

    const capitalize = (s) => {
        // if (typeof s !== 'string') return ''
        // return s.charAt(0).toUpperCase() + s.slice(1)

        return s.toUpperCase()
    }

    const fetchSiteLocationSensors = () => {
        return new Promise((resolve, reject) => {
            var data = {
                user_login: user.user_login,
                user_token: user.user_token,
                source: "D",
                criteria: {
                    from: 0,
                    size: 1000,
                    sensor_site_id: user.site_selected.site_id
                }
            }

            CommonUtils.ajax(
                {
                    url: API.COMMON_TABLE_OPERATIONS.REMOTE_SENSOR.FETCH,
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    if (res && res.status && res.status.code === 200) {
                        var data = res.data.records;
                        setSensorsInfo(data);
                        resolve();
                    }
                },
                (err) => {
                    setSensorsInfo([]);
                    resolve();
                }
            )
        })

    }

    const fetchEnvironmentalReport = () => {
        var payload = {
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            start_date: date ? (weekly ? moment(date, 'YYYY-MM-DD').add(-7, 'days').format('YYYY-MM-DD') : date) : moment().format('YYYY-MM-DD'),
            end_date: date ? date : moment().format('YYYY-MM-DD'),
            timezone: timezone
        }

        setDate(payload.end_date);

        CommonUtils.ajax(
            {
                url: API.DATA.ENVIRONMENTAL,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(payload)
            }
        ).then(
            (res) => {
                var chartData = {};
                if (res.status && res.status.code === 200) {

                    // chartPlugin = [{
                    //     afterDraw: (chart) => {
                    //         let datasetSize = chart.data.datasets.length;
                    //         if (datasetSize > 0) {

                    //             let lastDataSet = chart.data.datasets[datasetSize - 1];
                    //             // We might get with out no data dataset or one with empty data set.
                    //             if (lastDataSet.label === 'NO DATA' && lastDataSet.noData) {
                    //                 var ctx = chart.chart.ctx;
                    //                 ctx.save();
                    //                 ctx.textAlign = 'center';
                    //                 ctx.textBaseline = 'middle';
                    //                 ctx.font = "bold 14px sans-serif";
                    //                 ctx.fillStyle = "rgba(0,0,0,1)";
                    //                 ctx.fillText('No data available ...', chart.chart.width / 2, chart.chart.height / 2);
                    //                 ctx.restore();
                    //             }
                    //         }
                    //     }
                    // }];

                    let colors = ['#48C9B0', '#F5B041', '#3498DB', '#AF7AC5', '#21B345'];
                    var envUnitsMap = {
                        'temperature': 'F',
                        'humidity': '%',
                        'co': 'ppm',
                        'co2': 'ppm',
                        'voc': 'ppb',
                        'leak': '',
                        'flow': 'Gallons'
                    };
                    var data = res.data;
                    $('.datepicker').attr('readonly', 'true');

                    var sensors = ['temperature', 'humidity', 'CO', 'CO2', 'VOC'];
                    var dates = [];

                    if (data && data.length > 0) {
                        var startDate = payload.start_date;
                        while (startDate <= payload.end_date) {
                            dates.push(moment(startDate, 'YYYY-MM-DD').format('MMM DD'));
                            startDate = moment(startDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
                        }
                    }

                    let locationwise_env_data = {};
                    let sensorwise_env_data = {};

                    for (let d of data) {

                        if (d.sensor_id === 'humidity' || d.sensor_id === 'temperature') {
                            if (d.event_value && d.event_value === -100)
                                d.event_value = null;
                        }

                        if (d.sensor_name !== d.device_name)
                            continue;

                        if (d.sensor_id === 'co' || d.sensor_id === 'co2' || d.sensor_id === 'voc') {
                            d.sensor_id = d.sensor_id.toUpperCase();
                        }

                        if (!locationwise_env_data[d.location_id])
                            locationwise_env_data[d.location_id] = {};

                        if (!locationwise_env_data[d.location_id][d.sensor_id]) {
                            let dateMapDefaults = {};
                            for (let dd of dates) {
                                dateMapDefaults[dd] = [{ event_type: 'dummy', event_value: null, event_ts: dd + ', 00:00' }];
                            }
                            locationwise_env_data[d.location_id][d.sensor_id] = dateMapDefaults;
                            //console.log(JSON.stringify(locationwise_env_data[d.location_id][d.sensor_id]));
                        }

                        //console.log(JSON.stringify(locationwise_env_data));

                        var mmmdd = moment.tz(d.sec_timestamp * 1000, timezone).format('MMM DD');
                        var hhmm = moment.tz(d.sec_timestamp * 1000, timezone).format('HH:mm')
                        if (!locationwise_env_data[d.location_id][d.sensor_id][mmmdd]) {
                            locationwise_env_data[d.location_id][d.sensor_id][mmmdd] = [];
                        }
                        var event_val = d.sensor_id === 'humidity' && d.event_value >= 100 ? 99.9 : d.event_value;
                        locationwise_env_data[d.location_id][d.sensor_id][mmmdd].push({ event_value: event_val, event_ts: mmmdd + ', ' + hhmm });
                    }


                    for (let d of data) {
                        if (d.sensor_id === 'voc')
                            continue;

                        if (d.sensor_name === d.device_name)
                            continue;

                        if (!sensorwise_env_data[d.sensor_name])
                            sensorwise_env_data[d.sensor_name] = {};

                        if (!sensorwise_env_data[d.sensor_name][d.sensor_id]) {
                            let dateMapDefaults = {};
                            for (let dd of dates) {
                                dateMapDefaults[dd] = [{ event_type: 'dummy', event_value: null, event_ts: dd + ' 00:00' }];
                            }
                            sensorwise_env_data[d.sensor_name][d.sensor_id] = dateMapDefaults;
                        }

                        let mmmdd = moment.tz(d.sec_timestamp * 1000, timezone).format('MMM DD');
                        let hhmm = moment.tz(d.sec_timestamp * 1000, timezone).format('HH:mm')
                        if (!sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd]) {
                            sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd] = [];
                        }
                        let event_val = d.sensor_id === 'humidity' && d.event_value >= 100 ? 99.9 : d.event_value;
                        sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd].push({ event_loc: d.location_id, event_value: event_val, event_ts: mmmdd + ', ' + hhmm });
                    }

                    let sensorChartMap = {};
                    let locationChartMap = {};

                    for (let sensor_name_key in sensorwise_env_data) {
                        let sensorwise_data = {};
                        let locs_involved = {};
                        let sensorIds = Object.keys(sensorwise_env_data[sensor_name_key]);
                        let envParamsObj = {};

                        for (let x of sensorIds) {
                            envParamsObj[x] = null;
                        }

                        //console.log(JSON.stringify(sensorwise_env_data, null, 4))

                        for (let sensor_id_key in sensorwise_env_data[sensor_name_key]) {
                            for (let date_key in sensorwise_env_data[sensor_name_key][sensor_id_key]) {
                                for (let date_key_rec of sensorwise_env_data[sensor_name_key][sensor_id_key][date_key]) {
                                    if (date_key_rec.event_type === 'dummy' && sensorwise_env_data[sensor_name_key][sensor_id_key][date_key].length > 1) {
                                        continue;
                                    }
                                    if (!sensorwise_data[date_key_rec.event_ts]) {
                                        sensorwise_data[date_key_rec.event_ts] = JSON.parse(JSON.stringify(envParamsObj));
                                    }
                                    if (zonesMap[date_key_rec.event_loc])
                                        locs_involved[zonesMap[date_key_rec.event_loc]] = null;
                                    else
                                        console.log('Zone Value not found for ' + date_key_rec.event_loc);
                                    sensorwise_data[date_key_rec.event_ts][sensor_id_key] = date_key_rec.event_value;
                                }
                            }
                        }

                        //sensorChartData[sensor_name_key] = { locations: Object.keys(locs_involved), sensorData: sensorwise_data };
                        let sensor_info = [...sensors_info];
                        let sList = [];
                        for (let sensor of sensor_info) {
                            let s = { ...sensor };
                            s.sensor_name_key = s.sensor_type + "_" + s.sensor_id
                            sList.push(s);
                        }
                        setSensorsList(sList);
                        let sensor_serial_number = sList.find((s) => s.sensor_name_key === sensor_name_key) && sList.find((s) => s.sensor_name_key === sensor_name_key).sensor_serial_number;

                        sensorChartMap[sensor_name_key] = {
                            options: {
                                title: {
                                    fontColor: 'rgba(0, 0, 0)',
                                    display: true,
                                    text: (sensor_serial_number ? sensor_serial_number : "sensor " + sensor_name_key) + " seeing by " + Object.keys(locs_involved).join(',')  //"Sensor " + sensor_name_key + " seeing by " +
                                },
                                legend: {
                                    display: true
                                },
                                scales: {
                                    xAxes: [{
                                        categoryPercentage: 1.0,
                                        barPercentage: 1.0,
                                        ticks: {
                                            autoSkip: true
                                        },
                                        display: true,
                                        gridLines: {
                                            display: true
                                        },
                                        scaleLabel: {
                                            display: true,
                                            labelString: 'Hour',
                                            fontColor: 'orange'
                                        }
                                    }],
                                    yAxes: []
                                },
                                maintainAspectRatio: false
                            },

                            labels: [],
                            datasets: []
                        };

                        let labelsDateTimeSorted = Object.keys(sensorwise_data).sort((x, y) => { return moment(x, 'MMM DD, HH:mm').diff(moment(y, 'MMM DD, HH:mm'), 'hours', true) })
                        sensorChartMap[sensor_name_key].labels = labelsDateTimeSorted;
                        let envParamWiseData = JSON.parse(JSON.stringify(envParamsObj));

                        let idx = 0;
                        for (let envParam in envParamWiseData) {
                            let yKey = sensor_name_key + '-' + envParam;
                            sensorChartMap[sensor_name_key].options.scales.yAxes.push(
                                {
                                    display: true,
                                    gridLines: {
                                        display: false
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: "",
                                        fontColor: 'orange'
                                    },
                                    id: yKey,
                                    position: idx > 0 ? 'right' : 'left',
                                    ticks: {
                                        fontColor: colors[idx]
                                    },
                                    beforeBuildTicks: function (e) {
                                        e.options.display = (e.min !== -1);
                                        //console.log(e.options);
                                    }
                                }
                            );

                            let envParamData = [];
                            for (let date of sensorChartMap[sensor_name_key].labels) {
                                envParamData.push(sensorwise_data[date][envParam]);
                            }

                            let minmax = filter_sort([...envParamData]);
                            sensorChartMap[sensor_name_key].datasets.push(
                                {
                                    type: 'line',
                                    labelData: { label: capitalize(envParam), min: minmax[0], max: minmax[minmax.length - 1], units: envUnitsMap[envParam] },
                                    label: capitalize(envParam) + " (Min: " + minmax[0] + envUnitsMap[envParam] + ", Max: " + minmax[minmax.length - 1] + envUnitsMap[envParam] + ")",
                                    backgroundColor: 'rgba(0,0,0,0)',
                                    pointHoverBorderColor: colors[idx],
                                    pointBackgroundColor: colors[idx],
                                    borderColor: colors[idx],
                                    hoverBackgroundColor: 'rgba(0,123,255,0.9)',
                                    data: envParamData,
                                    yAxisID: yKey,
                                    pointRadius: 2
                                }
                            );
                            idx++;

                        }
                        addNoDataDataSet(sensorChartMap[sensor_name_key]);
                        //console.log(JSON.stringify(sensorChartMap[sensor_name_key]));
                    }

                    for (let loc_id_key in locationwise_env_data) {
                        if (!chartData[loc_id_key]) {
                            chartData[loc_id_key] = {}
                        }
                        let sensorwise_data = {};
                        let sensorIds = Object.keys(locationwise_env_data[loc_id_key]);
                        let envParamsObj = {};
                        for (let x of sensorIds) {
                            envParamsObj[x] = null;
                        }

                        for (let sensor_id_key in locationwise_env_data[loc_id_key]) {
                            if (sensors.indexOf(sensor_id_key) === -1)
                                continue;
                            for (let date_key in locationwise_env_data[loc_id_key][sensor_id_key]) {
                                for (let date_key_rec of locationwise_env_data[loc_id_key][sensor_id_key][date_key]) {
                                    if (date_key_rec.event_type === 'dummy' && locationwise_env_data[loc_id_key][sensor_id_key][date_key].length > 1) {
                                        continue;
                                    }
                                    if (!sensorwise_data[date_key_rec.event_ts]) {
                                        sensorwise_data[date_key_rec.event_ts] = JSON.parse(JSON.stringify(envParamsObj));
                                    }
                                    //locs_involved[this.zonesMap[date_key_rec.event_loc]] = null;
                                    sensorwise_data[date_key_rec.event_ts][sensor_id_key] = date_key_rec.event_value;
                                }
                            }
                        }

                        locationChartMap[loc_id_key] = {
                            options: {
                                title: {
                                    fontColor: 'rgba(0, 0, 0)',
                                    display: true,
                                    text: zonesMap[loc_id_key]
                                },
                                legend: {
                                    display: true
                                },
                                scales: {
                                    xAxes: [{
                                        categoryPercentage: 1.0,
                                        barPercentage: 1.0,
                                        ticks: {
                                            autoSkip: true
                                        },
                                        display: true,
                                        gridLines: {
                                            display: true
                                        },
                                        scaleLabel: {
                                            display: true,
                                            labelString: 'Hour',
                                            fontColor: 'orange'
                                        }
                                    }],
                                    yAxes: []
                                },
                                maintainAspectRatio: false
                            },

                            labels: [],
                            datasets: []
                        };

                        let labelsDateTimeSorted = Object.keys(sensorwise_data).sort((x, y) => { return moment(x, 'MMM DD, HH:mm').diff(moment(y, 'MMM DD, HH:mm'), 'hours', true) })
                        locationChartMap[loc_id_key].labels = labelsDateTimeSorted;
                        let envParamWiseData = JSON.parse(JSON.stringify(envParamsObj));
                        let idx = 0;
                        for (let envParam in envParamWiseData) {
                            let yKey = loc_id_key + '-' + envParam;
                            locationChartMap[loc_id_key].options.scales.yAxes.push(
                                {
                                    display: true,
                                    gridLines: {
                                        display: false
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: "",
                                        fontColor: 'orange'
                                    },
                                    id: yKey,
                                    position: idx > 0 ? 'right' : 'left',
                                    ticks: {
                                        fontColor: colors[idx]
                                    },
                                    beforeBuildTicks: function (e) {
                                        e.options.display = (e.min !== -1);
                                        //console.log(e.options);
                                    }
                                }
                            );
                            let envParamData = [];
                            for (let date of locationChartMap[loc_id_key].labels) {
                                envParamData.push(sensorwise_data[date][envParam]);
                            }
                            let minmax = filter_sort([...envParamData]);
                            locationChartMap[loc_id_key].datasets.push(
                                {
                                    type: 'line',
                                    labelData: { label: capitalize(envParam), min: minmax[0], max: minmax[minmax.length - 1], units: envUnitsMap[envParam] },
                                    label: capitalize(envParam) + " (Min: " + minmax[0] + envUnitsMap[envParam] + ", Max: " + minmax[minmax.length - 1] + envUnitsMap[envParam] + ")",
                                    backgroundColor: 'rgba(0,0,0,0)',
                                    pointHoverBorderColor: colors[idx],
                                    pointBackgroundColor: colors[idx],
                                    borderColor: colors[idx],
                                    hoverBackgroundColor: 'rgba(0,123,255,0.9)',
                                    data: envParamData,
                                    yAxisID: yKey,
                                    pointRadius: 2
                                }
                            );
                            idx++;
                        }
                        addNoDataDataSet(locationChartMap[loc_id_key]);
                    }

                    //console.log(JSON.stringify(sensorwise_env_data));
                    //console.log(JSON.stringify(sensorChartData));

                    setLocationChartData(locationChartMap);
                    setSensorChartData(sensorChartMap);
                }

                setTimeout(function () { window.status = 'ready'; }, 2000);
            },
            (res) => {
                $('.datepicker').attr('readonly', 'true');
                setTimeout(function () { window.status = 'ready'; }, 2000);
            });
    }

    const addNoDataDataSet = (chart) => {
        let dataSetsSize = chart.datasets.length;
        let maxVal = 0;
        let dataFoundPoints = 0;
        let missingData = chart.datasets[0].data.map((v, idx) => {
            let foundVal = false;
            for (let i = 0; i < dataSetsSize; i++) {
                if (chart.datasets[i].data[idx]) {
                    if (chart.datasets[i].data[idx] > maxVal) {
                        maxVal = chart.datasets[i].data[idx];
                    }
                    foundVal = true;
                }
            }
            if (foundVal)
                dataFoundPoints++;
            return foundVal ? 0 : 1;
        });

        if (maxVal === 0 && dataFoundPoints === 0) {
            maxVal = 100;
        }

        for (let i = 0; i < missingData.length; i++) {
            if (missingData[i] === 1)
                missingData[i] = maxVal;
        }

        let dataLen = missingData.length;
        if (dataFoundPoints !== dataLen) {
            console.log('Not found data for few ...');
            let yKey = new Date().getMilliseconds();
            let newDataSet = {
                noData: (dataFoundPoints === 0),
                type: 'bar',
                label: 'NO DATA',
                backgroundColor: '#dedede',
                borderColor: '#dedede',
                borderWidth: 0,
                hoverBackgroundColor: '#dedede',
                hoverBorderColor: '#dedede',
                data: missingData,
                yAxisID: yKey
            };
            console.log('Updating the chart ... newDataSet ', newDataSet);
            chart.datasets.push(newDataSet);
            let ticksObj = { display: false }
            if (dataFoundPoints === 0) {
                ticksObj = {
                    display: false,
                    beginAtZero: true,
                    steps: 10,
                    stepValue: 10,
                    max: 100
                };
            }
            chart.options.scales.yAxes.push({
                display: true,
                gridLines: {
                    display: false
                },
                scaleLabel: {
                    display: true,
                    labelString: "",
                    fontColor: 'orange'
                },
                ticks: ticksObj,
                id: yKey,
                position: 'right',
                beforeBuildTicks: function (e) {
                    e.options.display = (e.min !== -1);
                }
            });
        }
    }

    const filter_sort = (test_array) => {
        var index = -1,
            arr_length = test_array ? test_array.length : 0,
            resIndex = -1,
            result = [];

        while (++index < arr_length) {
            var value = test_array[index];

            if (value !== null) {
                result[++resIndex] = parseFloat(value);
            }
        }

        if (result.length > 0) {
            result = result.sort((a, b) => a - b);
        }

        return result.length === 0 ? ['-'] : result;
    }


    var envData = locationChartData;

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12 my-5">
                    <span className="navbar-brand text-primary">
                        <img src={logo} alt="logo" style={{ width: "25px", marginRight: '10px' }} />
                        {"SiteSupt OnDemand"}
                    </span>
                </div>
            </div>
            {
                locationChartData &&
                <div className="row">
                    <div className="col-md-12">
                        <h4>{pdfTitle}</h4>
                    </div>
                    <div className="col-md-12">
                        <h5 className="text-app">{user && user.site_selected.site_name}</h5> <br />
                        <b>Start Date</b>: {moment(date, 'YYYY-MM-DD').add(weekly ? -7 : 0, 'days').format('MMM DD, YYYY')} <br />
                        <b>End Date</b>: {moment(date, 'YYYY-MM-DD').format('MMM DD, YYYY')}
                    </div>
                </div>
            }

            <div className="row">
                <div className="col-md-12">
                    <table className="bg-white" style={{ width: '100%' }}>
                        <tbody>
                            {
                                sensorChartData && Object.keys(sensorChartData).length > 0 && (
                                    <>
                                        <tr>
                                            <td className="mt-5 bg-white">&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td className="mt-5 bg-white mt-5"><h5>Sensor Report</h5></td>
                                        </tr>
                                    </>
                                )
                            }

                            {
                                sensorChartData && Object.keys(sensorChartData).map((z, i) => {
                                    let sensor_serial_number = sensorsList && sensorsList.find((s) => s.sensor_name_key === z);
                                    sensor_serial_number = sensor_serial_number && sensor_serial_number.sensor_serial_number
                                    return (
                                        <React.Fragment key={i}>
                                            <div className='card my-2 bg-shadow mt-4 align-print-page'>
                                                <div className="card-header bg-primary text-light p-2">{sensor_serial_number ? sensor_serial_number : z}</div>
                                                <div className="card-body text-center">
                                                    <Line
                                                        style={{ position: "relative" }}
                                                        data={sensorChartData[z]}
                                                        height={350}
                                                        options={sensorChartData[z].options}
                                                    />
                                                </div>
                                            </div>

                                        </React.Fragment>
                                    )
                                })
                            }

                            {
                                locationChartData && Object.keys(locationChartData).length > 0 && (
                                    <>
                                        <tr>
                                            <td className="mt-5 bg-white">&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td className="mt-5 bg-white"><h5>Zones Report</h5></td>
                                        </tr>
                                    </>
                                )
                            }

                            {
                                locationChartData && Object.keys(zones).map((z, i) => (
                                    <React.Fragment key={i}>
                                        <div className='card my-2 bg-shadow mt-4 align-print-page'>
                                            <div className="card-header bg-primary text-light p-2">{zones[z]['location_name']}</div>
                                            <div className="card-body text-center">
                                                {
                                                    envData[zones[z]['location_id']] ?
                                                        <Line
                                                            style={{ position: "relative" }}
                                                            data={envData[zones[z]['location_id']]}
                                                            height={350}
                                                            options={envData[zones[z]['location_id']].options}
                                                        />
                                                        : "No environmental data found ..."
                                                }
                                            </div>
                                        </div>

                                    </React.Fragment>
                                ))
                            }

                        </tbody>
                    </table>
                </div>
            </div >
            <div className="row">
                <div className="col-md-12">
                    <div className="text-small">
                        <b>Disclaimer</b>: There are several factors that may create a spot reading that may deviate from average and impact the sensor reported data. Please see the following factors including and not limited to radiant heat, directed heat/cold sources, airflow, thermal conductivity inertia, sensors technology accuracy, cellular connectivity, power and several other factors including unknown factors and it is highly recommended to also check the environment with additional sensor readings. These factors may create an additional shift in the sensor readings depending on the sensors' exposure to these factors.
                    </div>
                </div>
            </div>
        </div >
    )

}
export default EnvironmentalReport;